import { create } from "zustand"

type AssignUserDialogState = {
  isOpen: boolean
}

type AssignUserDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useAssignUserDialogV1 = create<
  AssignUserDialogState & AssignUserDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useAssignUserDialogV1
